export default __webpack_public_path__ + "static/Principle-profil-dark-246813465fc263b019200897f6079715.png";